export { createSmartImage } from "./create-smart-image.js";
export type {
  CreateSmartImageOptions,
  SmartImageClassNameFn,
  SmartImageComponent,
} from "./create-smart-image.types.js";
export { SmartImage } from "./smart-image.js";
export type { SmartImageProps } from "./smart-image.types.js";
